<template>
    <div>
        <div v-show="reviews.length === 0">
            <l-no-data :text="$t(`profile.feedback.empty`)" icon="/img/icons/feedback.png" />
        </div>

        <div v-for="review in reviews" :key="review._id">
            <a
                class="fake-link"
                :href="
                    `#/reviews/update/${review.reviewCycle}/reviewee/${reviewCycle.revieweeUser._id}/manager/${user._id}/viewAs/owner/overview/adminByUser`
                "
                target="_blank"
            >
                {{ review.name }}
            </a>
            <br />
            <span class="color-grey">
                {{ review.date | moment("MMM DD, YYYY") }}
            </span>

            <div class="hr-small"></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LNoData from "@/components/LNoData";

export default {
    components: {
        LNoData,
    },
    props: {
        reviews: {
            type: Array,
            required: true,
        },
        reviewCycle: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
        }),
    },
};
</script>
